import script from "./electricPile.vue?vue&type=script&setup=true&lang=js"
export * from "./electricPile.vue?vue&type=script&setup=true&lang=js"

import "./electricPile.vue?vue&type=style&index=0&id=fced07ee&lang=scss"

const __exports__ = script;

export default __exports__